export enum Locale {
    Da = 'da',
    En = 'en',
    No = 'no'
}